import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { ElMessage } from 'element-plus'

/**
 * 登录相关的组合式函数
 * 封装登录表单逻辑和用户认证流程
 */
export function useLogin() {
  const router = useRouter()
  const userStore = useUserStore()
  
  // 表单引用
  const loginFormRef = ref(null)
  
  // 登录表单数据
  const loginForm = reactive({
    username: '',
    password: ''
  })
  
  // 表单验证规则
  const rules = {
    username: [
      { required: true, message: '请输入用户名', trigger: 'blur' },
      { min: 2, max: 20, message: '用户名长度在 2 到 20 个字符', trigger: 'blur' }
    ],
    password: [
      { required: true, message: '请输入密码', trigger: 'blur' },
      { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
    ]
  }
  
  // 加载状态
  const loading = ref(false)
  
  /**
   * 处理登录
   */
  const handleLogin = async () => {
    if (!loginFormRef.value) return
    
    try {
      // 验证表单
      const valid = await loginFormRef.value.validate()
      if (!valid) return
      
      loading.value = true
      
      // 调用用户store的登录方法
      const result = await userStore.login({
        username: loginForm.username,
        password: loginForm.password
      })
      
      if (result.success) {
        ElMessage.success('登录成功！')
        
        // 根据用户角色跳转到不同页面
        const userRole = result.user.role
        if (userRole === 'ROLE_ADMIN') {
          router.push('/admin')
        } else if (userRole === 'ROLE_AFTER_SALES') {
          router.push('/admin')
        } else if (userRole === 'ROLE_TECHNICIAN') {
          router.push('/fixer')
        } else {
          // 默认跳转到管理员页
          router.push('/')
        }
      } else {
        ElMessage.error(result.error || '登录失败，请检查用户名和密码')
      }
    } catch (error) {
      console.error('登录过程中发生错误:', error)
      ElMessage.error(error?.message || '登录失败，请稍后重试')
    } finally {
      loading.value = false
    }
  }
  
  return {
    loginFormRef,
    loginForm,
    rules,
    loading,
    handleLogin
  }
}
